import { Button, Dialog, DialogActions, DialogContent, Grid, TextField } from '@mui/material';
import React from 'react';
import { DialogHeader } from '../Modals';
import { useFormContext } from 'react-hook-form';

interface IProps {
  open: boolean;
  close: () => void;
}
const InferenceSettings = ({ open, close }) => {
  const {
    register,
    getValues,
    setValue,
    control,
    formState: { errors },
    reset,
    watch,
  } = useFormContext();

  const watchInterfaceType = watch('interfaceType', 'Form');
  return (
    <Dialog open={open} onClose={close} maxWidth="sm" fullWidth={true}>
      <DialogHeader onClose={() => close(false)}>Interface Settings</DialogHeader>
      <DialogContent dividers>
        <Grid container spacing={3}>
          <Grid item xs={12}>
          <TextField
              fullWidth
              label="Chatbot Start Message"
              variant="outlined"
              size="small"
              disabled={false}
              placeholder="Enter Chatbot Start Message"
              {...register('interfaceDisplayOptions.chatbotStartMessage', {required:true})}
                
            ></TextField>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default InferenceSettings;
